import React from 'react';
import { Button, Modal, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isEmailValid, isNameValid } from 'services/Validation';

class AddOrg extends React.Component {
    constructor(props) {
        super(props);

        const { id, thumb, name, email, phone, designation, selected, starred, frequently, role, surveys } = props.organisation;
        this.state = {
            id,
            thumb,
            name,
            email,
            phone,
            designation,
            selected,
            starred,
            frequently,
            role,
            surveys,
            nameValid: isNameValid(name),
            emailValid: isEmailValid(email),
            formErrors: { name: '', email: '' },
            formValid: false,
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let nameValid = this.state.nameValid;
        let emailValid = this.state.emailValid;

        switch (fieldName) {
            case 'name':
                nameValid = isNameValid(value);
                fieldValidationErrors.name = nameValid ? '' : ' is invalid';
                break;
            case 'email':
                emailValid = isEmailValid(value);
                fieldValidationErrors.email = emailValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            nameValid: nameValid,
            emailValid: emailValid,
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.nameValid && this.state.emailValid });
    }

    render() {
        const { onSaveOrg, showOrgLoader, onOrgClose, open, organisation } = this.props;
        const { id, name, email, phone, role, surveys, designation, selected, starred, frequently } = this.state;
        const isNew = organisation.name === '';
        let { thumb } = this.state;
        return (
            <Modal className="modal-box" toggle={onOrgClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    {isNew ? <IntlMessages id="org.addOrg" /> :
                        <IntlMessages id="org.saveOrg" />}
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onOrgClose} />
                    </span>
                </ModalHeader>

                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <div className="col-lg-3 text-center text-lg-right order-lg-2">
                            <img className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={thumb} />
                        </div>

                        <div className="panel panel-default">
                            <FormErrors formErrors={this.state.formErrors} />
                        </div>

                        <div className="col-lg-9 d-flex flex-column order-lg-1">
                            <input type="text" className="form-control mb-2"
                                placeholder="Organisation Name"
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={name} name="name"
                            />
                            <input type="text" className="form-control mb-2"
                                placeholder="Administrators Email"
                                onChange={(event) => this.handleUserInput(event)}
                                value={email} name="email"
                            />
                            <input type="text" className="form-control mb-2"
                                placeholder="Adminstrators Phone"
                                onChange={(event) => this.setState({ phone: event.target.value })}
                                value={phone} name="phone"
                            />
                            <input type="text" className="form-control mb-2"
                                placeholder="Department/ Position"
                                onChange={(event) => this.setState({ designation: event.target.value })}
                                value={designation} name="desgination"
                            />
                        </div>
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                        showOrgLoader();
                        onOrgClose();
                        onSaveOrg(
                            {
                                'id': id,
                                'name': name,
                                'thumb': null,
                                'email': email,
                                'phone': phone,
                                'designation': designation,
                                'selected': selected,
                                'starred': starred,
                                'frequently': frequently,
                                'role': role,
                                'surveys': surveys,
                            });
                        this.setState({
                            id: '',
                            name: '',
                            thumb: null,
                            email: '',
                            phone: '',
                            designation: '',
                            selected: false,
                            starred: false,
                            frequently: false,
                            role: '',
                            surveys: [],
                            formErrors: { name: '', email: '' },
                            formValid: false,
                        });

                    }}>
                        {isNew ? <IntlMessages id="org.addOrg" /> :
                            <IntlMessages id="org.saveOrg" />}</Button>
                </div>
            </Modal>
        );
    }
}

export default AddOrg;


// WEBPACK FOOTER //
// ./components/Agile/Organisation/AddOrg/index.js